module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-breadcrumb-item', {
    staticClass: "ml-2 mr-2",
    staticStyle: {
      "border": "5px"
    },
    on: {
      "click": function($event) {
        _vm.viewBRFDetails()
      }
    }
  }, [_c('b-badge', {
    staticStyle: {
      "font-size": "100%",
      "color": "red"
    }
  }, [_c('b', [_vm._v("View BRF")])])], 1), _vm._v(" "), _c('b-modal', {
    ref: "viewBRFDetails-modal",
    attrs: {
      "id": "viewBRFDetails-modal",
      "title": 'BRF Details-' + _vm.getBRFList.BookingNo,
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [(_vm.getBRFList) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getBRFList.TransportType) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "client-details"
  }, [_c('h6', {
    staticClass: "card-title"
  }, [_vm._v("Shipping Details")]), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Transport Type:")]), _vm._v("\n                  " + _vm._s(_vm.getBRFList.TransportType || "N/A") + "\n                ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Shipment Type:")]), _vm._v("\n                  " + _vm._s(_vm.getBRFList.ShipemntType || "N/A") + "\n                ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Billing Type:")]), _vm._v("\n                  " + _vm._s(_vm.getBRFList.BillingType || "N/A") + "\n                ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Shipper:")]), _vm._v("\n                  " + _vm._s(_vm.getBRFList.ClientName || "N/A") + "\n                ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Shipping Line:")]), _vm._v("\n                  " + _vm._s(_vm.getBRFList.ShippingLine || "N/A") + "\n                ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Empty Pickup:")]), _vm._v(" " + _vm._s(_vm.getBRFList.EmptyPickup || "N/A") + "\n                ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("POR (Port of Receipt):")]), _vm._v("\n                  " + _vm._s(_vm.getBRFList.Por || "N/A") + "\n                ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("POL (Port of Loading):")]), _vm._v("\n                  " + _vm._s(_vm.getBRFList.Pol || "N/A") + "\n                ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("POD (Port of Discharge):")]), _vm._v("\n                  " + _vm._s(_vm.getBRFList.Pod || "N/A") + "\n                ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Final POD:")]), _vm._v(" " + _vm._s(_vm.getBRFList.Fpod || "N/A") + "\n                ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Inco Term:")]), _vm._v(" " + _vm._s(_vm.getBRFList.IncoTerm || "N/A") + "\n                ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Spot/Non-Spot:")]), _vm._v("\n                  " + _vm._s(_vm.getBRFList.SpotNonSpot || "N/A") + "\n                ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Delivery Mode:")]), _vm._v("\n                  " + _vm._s(_vm.getBRFList.DeliveryMode || "N/A") + "\n                ")]), _vm._v(" "), (_vm.getBRFList.HandoverDate) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Handover Date:")]), _vm._v("\n                  " + _vm._s(_vm.getBRFList.HandoverDate) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("ETD/SOB:")]), _vm._v("\n                  " + _vm._s(_vm.getBRFList.Etd) + "\n                ")])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h6', {
    staticClass: "card-title"
  }, [_vm._v("Container Details")]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Container Type")]), _vm._v(" "), _c('th', [_vm._v("Rate Per Unit")]), _vm._v(" "), _c('th', [_vm._v("Booking No")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.CONTAINERCOUNTArr), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.containerTypeName + 'X' + item.brcm_tot_continer))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.brcm_rate + ' ' + item.currencyCodeName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.booking_no))])])
  }))])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('b-row', [(_vm.getBRFList.BookingNo) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("BRF No:")]), _vm._v(" " + _vm._s(_vm.getBRFList.BookingNo || "N/A") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.EnquiryNo) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Enq No:")]), _vm._v(" " + _vm._s(_vm.getBRFList.EnquiryNo || "N/A") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.RaisedFrom) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Branch:")]), _vm._v(" " + _vm._s(_vm.getBRFList.RaisedFrom || "N/A") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.CreatedByUser) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Created By:")]), _vm._v(" " + _vm._s(_vm.getBRFList.CreatedByUser || "N/A") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.CreatedAt) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Created At:")]), _vm._v(" " + _vm._s(_vm.getBRFList.CreatedAt) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.CurrencyName) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Currency:")]), _vm._v(" " + _vm._s(_vm.getBRFList.CurrencyName || "N/A") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.CurrencyCountryName) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Currency Country:")]), _vm._v("\n                  " + _vm._s(_vm.getBRFList.CurrencyCountryName || "N/A") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.MasterCurrencyCode) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Master Currency Code:")]), _vm._v("\n                  " + _vm._s(_vm.getBRFList.MasterCurrencyCode || "N/A") + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.getBRFList.BookingNo) ? _c('h6', {
    staticClass: "card-title"
  }, [_vm._v("Booking Details-" + _vm._s(_vm.getBRFList.BookingNo))]) : _vm._e(), _vm._v(" "), _c('b-row', [(_vm.getBRFList.BookingNo) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Booking No:")]), _vm._v(" " + _vm._s(_vm.getBRFList.BookingNo || "N/A") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.EnquiryNo) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Enquiry No:")]), _vm._v(" " + _vm._s(_vm.getBRFList.EnquiryNo || "N/A") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.RaNumber) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("RA Number:")]), _vm._v(" " + _vm._s(_vm.getBRFList.RaNumber || "N/A") + "\n                ")]) : _vm._e(), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Quotation Till Status:")]), _vm._v("\n                  " + _vm._s(_vm.getBRFList.QuotationTillStatus || "N/A") + "\n                ")]), _vm._v(" "), (_vm.getBRFList.ValidForSail) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Valid For Sail:")]), _vm._v("\n                  " + _vm._s(_vm.getBRFList.ValidForSail || "N/A") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.ValidTill) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Valid Till:")]), _vm._v(" " + _vm._s(_vm.getBRFList.ValidTill || "N/A") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.TemplateName) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Template Name:")]), _vm._v("\n                  " + _vm._s(_vm.getBRFList.TemplateName || "N/A") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.TemplateValidTill) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Template Valid Till:")]), _vm._v("\n                  " + _vm._s(_vm.getBRFList.TemplateValidTill) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h6', {
    staticClass: "card-title"
  }, [_vm._v("Commodity Details")]), _vm._v(" "), _c('b-row', [(_vm.getBRFList.CommodityType) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Commodity Type:")]), _vm._v("\n                  " + _vm._s(_vm.getBRFList.CommodityType || "N/A") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.OtherCommodity) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Other Commodity:")]), _vm._v("\n                  " + _vm._s(_vm.getBRFList.OtherCommodity || "N/A") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.PackingCode) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Packing Code:")]), _vm._v(" " + _vm._s(_vm.getBRFList.PackingCode || "N/A") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.ImdgClass) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("IMDG Class:")]), _vm._v(" " + _vm._s(_vm.getBRFList.ImdgClass || "N/A") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.UnNumber) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("UN Number:")]), _vm._v(" " + _vm._s(_vm.getBRFList.UnNumber || "N/A") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.TemperatureRequired) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Temperature Required:")]), _vm._v("\n                  " + _vm._s(_vm.getBRFList.TemperatureRequired || "N/A") + "°C\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.Humidity) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Humidity:")]), _vm._v(" " + _vm._s(_vm.getBRFList.Humidity || "N/A") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.CargoWeight) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Cargo Weight:")]), _vm._v("\n                  " + _vm._s(_vm.getBRFList.CargoWeight || "N/A") + " kg\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.CommodityItemName) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Commodity Item Name:")]), _vm._v("\n                  " + _vm._s(_vm.getBRFList.CommodityItemName || "N/A") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.CommodityHsnCode) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Commodity HSN Code:")]), _vm._v("\n                  " + _vm._s(_vm.getBRFList.CommodityHsnCode || "N/A") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.CommodityItemHsnCode) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Commodity Item HSN Code:")]), _vm._v("\n                  " + _vm._s(_vm.getBRFList.CommodityItemHsnCode || "N/A") + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h6', {
    staticClass: "card-title"
  }, [_vm._v("Rate & Free Days")]), _vm._v(" "), _c('b-row', [(_vm.getBRFList.RateAgreed) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Rate Agreed:")]), _vm._v(" " + _vm._s(_vm.getBRFList.RateAgreed || "N/A") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.FreeDays) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("FREE DAYS AT POD:")]), _vm._v(" " + _vm._s(_vm.getBRFList.FreeDays || "N/A") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.SiCutOfDate) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("SI CUT OFF:")]), _vm._v(" " + _vm._s(_vm.getBRFList.SiCutOfDate || "N/A") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.FreightTermsMbl) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("FREIGHT TERMS ( MBL):")]), _vm._v(" " + _vm._s(_vm.getBRFList.FreightTermsMbl || "N/A") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.FreightTermsHbl) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("FREIGHT TERMS HBL:")]), _vm._v(" " + _vm._s(_vm.getBRFList.FreightTermsHbl || "N/A") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.DestinationCharges) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("DESTINATION CHARGES:")]), _vm._v(" " + _vm._s(_vm.getBRFList.DestinationCharges || "N/A") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.DestinationChargesDet) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("DESTINATION CHARGES Det.:")]), _vm._v(" " + _vm._s(_vm.getBRFList.DestinationChargesDet || "N/A") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.FirstMileBooking) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("FIRST MILE BOOKING:")]), _vm._v(" " + _vm._s(_vm.getBRFList.FirstMileBooking || "N/A") + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h6', {
    staticClass: "card-title"
  }, [_vm._v("Instructions & Remarks")]), _vm._v(" "), _c('b-row', [(_vm.getBRFList.BlInstruction) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "6"
    }
  }, [_c('strong', [_vm._v("BL Instruction:")]), _vm._v("\n                  " + _vm._s(_vm.getBRFList.BlInstruction || "N/A") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.Remarks) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "6"
    }
  }, [_c('strong', [_vm._v("Remarks:")]), _vm._v("\n                  " + _vm._s(_vm.getBRFList.Remarks || "N/A") + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h6', {
    staticClass: "card-title"
  }, [_vm._v("Agent Details")]), _vm._v(" "), _c('b-row', [(_vm.getBRFList.AgentCategoryType) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Agent Category Type:")]), _vm._v("\n                  " + _vm._s(_vm.getBRFList.AgentCategoryType || "N/A") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.AgentName) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Agent Name:")]), _vm._v(" " + _vm._s(_vm.getBRFList.AgentName || "N/A") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.CoLoaderName) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Co-Loader Name:")]), _vm._v("\n                  " + _vm._s(_vm.getBRFList.CoLoaderName || "N/A") + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h6', {
    staticClass: "card-title"
  }, [_vm._v("Status Flags")]), _vm._v(" "), _c('b-row', [(_vm.getBRFList.IsUsed) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Is Used:")]), _vm._v(" "), _c('span', {
    class: _vm.flagClass(_vm.getBRFList.IsUsed)
  }, [_vm._v("\n                    " + _vm._s(_vm.getBRFList.IsUsed === "Yes" ? "Yes" : "No") + "\n                  ")])]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.IsActive) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Is Active:")]), _vm._v(" "), _c('span', {
    class: _vm.flagClass(_vm.getBRFList.IsActive)
  }, [_vm._v("\n                    " + _vm._s(_vm.getBRFList.IsActive === "Yes" ? "Active" : "Inactive") + "\n                  ")])]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.IsDeleted) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Is Deleted:")]), _vm._v(" "), _c('span', {
    class: _vm.flagClass(_vm.getBRFList.IsDeleted)
  }, [_vm._v("\n                    " + _vm._s(_vm.getBRFList.IsDeleted === "Yes" ? "Yes" : "No") + "\n                  ")])]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.IsEnqPricingClosed) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Is Enquiry Pricing Closed:")]), _vm._v(" "), _c('span', {
    class: _vm.flagClass(_vm.getBRFList.IsEnqPricingClosed)
  }, [_vm._v("\n                    " + _vm._s(_vm.getBRFList.IsEnqPricingClosed === "Yes" ? "Closed" : "Open") + "\n                  ")])]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.IsEnqPricingUsed) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Is Enquiry Pricing Used:")]), _vm._v(" "), _c('span', {
    class: _vm.flagClass(_vm.getBRFList.IsEnqPricingUsed)
  }, [_vm._v("\n                    " + _vm._s(_vm.getBRFList.IsEnqPricingUsed === "Yes" ? "Used" : "Not Used") + "\n                  ")])]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.IsEnqPricingActive) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Is Enquiry Pricing Active:")]), _vm._v(" "), _c('span', {
    class: _vm.flagClass(_vm.getBRFList.IsEnqPricingActive)
  }, [_vm._v("\n                    " + _vm._s(_vm.getBRFList.IsEnqPricingActive === "Yes" ? "Active" : "Inactive") + "\n                  ")])]) : _vm._e()], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h6', {
    staticClass: "card-title"
  }, [_vm._v("Container Details")]), _vm._v(" "), _c('b-row', [(_vm.getBRFList.ContainerType) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Container Type:")]), _vm._v("\n                  " + _vm._s(_vm.getBRFList.ContainerType || "N/A") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.TuesCount) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Tues Count:")]), _vm._v(" " + _vm._s(_vm.getBRFList.TuesCount || "N/A") + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h6', {
    staticClass: "card-title"
  }, [_vm._v("PRBR Details")]), _vm._v(" "), _c('b-row', [(_vm.getBRFList.prbr_is_used) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("PRBR Is Used:")]), _vm._v("\n                  " + _vm._s(_vm.getBRFList.prbr_is_used === 1 ? "Yes" : "No") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.prbr_is_active) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("PRBR Is Active:")]), _vm._v("\n                  " + _vm._s(_vm.getBRFList.prbr_is_active === 1 ? "Active" : "Inactive") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.prbr_is_deleted) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("PRBR Is Deleted:")]), _vm._v("\n                  " + _vm._s(_vm.getBRFList.prbr_is_deleted === 1 ? "Yes" : "No") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.is_new_book_resp) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Is New Book Resp:")]), _vm._v("\n                  " + _vm._s(_vm.getBRFList.is_new_book_resp === 1 ? "Yes" : "No") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.prbr_id) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("PRBR ID:")]), _vm._v(" " + _vm._s(_vm.getBRFList.prbr_id || "N/A") + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h6', {
    staticClass: "card-title"
  }, [_vm._v("Additional Details")]), _vm._v(" "), _c('b-row', [(_vm.getBRFList.companyType) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Type of Company:")]), _vm._v("\n                  " + _vm._s(_vm.getBRFList.companyType || "N/A") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.stateName) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("State:")]), _vm._v(" " + _vm._s(_vm.getBRFList.stateName || "N/A") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.permitted) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Company Permitted:")]), _vm._v("\n                  " + _vm._s(_vm.getBRFList.permitted || "N/A") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.tanNO) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("TAN No:")]), _vm._v(" " + _vm._s(_vm.getBRFList.tanNO || "N/A") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.GSTN) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("GSTN No:")]), _vm._v(" " + _vm._s(_vm.getBRFList.GSTN || "N/A") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.corporateAddress) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Corporate Address:")]), _vm._v("\n                  " + _vm._s(_vm.getBRFList.corporateAddress || "N/A") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.getBRFList.Pda) ? _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("PDA:")]), _vm._v(" " + _vm._s(_vm.getBRFList.Pda || "N/A") + "\n                ")]) : _vm._e()], 1)], 1)])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right mt-2",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.hideviewBRFDetails
    }
  }, [_vm._v("\n      Close")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0414c1bc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/brfCard.vue
// module id = 2356
// module chunks = 0